import React from 'react'

function IndLic() {
  return (
    <>
     <head style={{all:'initial'}}>
                <title>إجراءات تأسيس فرع شركة أجنبية</title>
                <meta name="description" content="إجراءات تأسيس فرع شركة أجنبية"/>
                <meta name="keywords" content="إجراءات تأسيس فرع شركة أجنبية" />
            </head>
      <div style={{ padding: '50px', fontSize: '10px' }}>
          <h1>
              تقدم هذه الخدمة لجميع التراخيص الصناعية مثل
              <br />
              الصناعات الثقيلة والخفيفة، والصناعات التحويلية. 
          </h1>
      </div>
    </>
  )
}

export default IndLic